var $d96f2251ced25e45$exports = {};
$d96f2251ced25e45$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obligatorio)`
};


export {$d96f2251ced25e45$exports as default};
//# sourceMappingURL=es-ES.module.js.map
